








import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

@Component
export default class StudentLabel extends ViewBase {
  @Prop({ type: String, default: '' }) status!: string
  @Prop({ type: String, default: '' }) name!: string
  @Prop({ type: String, default: '' }) rate!: string

  lang = {}
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.lang = this.i18n.vBinding
  }
}
